// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ZiRN","title":"styles_title__3yuwZ"};